<template>
    <div>
        <img src="../src/assets/projects/skincare.png" style="width: 100%; " />
    </div>
    <div class="big-title1 mr-100">
        <span class="big-title-art1">S</span>HOP ALL
    </div>
    <section class="products-section">
        <Product :products="products"></Product>
    </section>

    <div style="display: flex; justify-content: center; margin: 100px; ">
        <el-pagination background layout="prev, pager, next" :total="10" />
    </div>
</template>

<script>
    import Product from '../src/components/Product.vue'

    export default {
        name: 'Shop',
        data() {
            return {
                products: [],

            }
        },
        components: {
            Product
        },
        mounted() {
            this.loadData();
        }, methods: {
            async loadData() {
                try {
                    const response = await fetch('/products.json'); // 注意路径应为相对于public文件夹的路径，或者使用绝对路径如`/data/file.json`
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    this.products = data;

                    for (var i = 0; i < this.products.length; i++) {
                        let num = this.products[i].image;
                        const image = require(`@/assets/projects/${num}.jpg`);
                        this.products[i].image = image;
                    }
                } catch (error) {
                    console.error('There has been a problem with your fetch operation:', error);
                }
            },
        }
    }
</script>

<style scoped>
    
</style>